export default __webpack_public_path__ + "static/media/640_store03-es-mobile.30e1377e.png";